export const SAVE_NOTE_TEXT = "SAVE_NOTE_TEXT";
export const SAVE_ATTACHMENT = "SAVE_ATTACHMENT";
export const DELETE_ATTACHMENT = "DELETE_ATTACHMENT";
export const DELETE_NOTE_DATA = "DELETE_NOTE_DATA";
export const SET_NOTE_ERROR = "SET_NOTE_ERROR";
export const SET_NOTE_SUCCESS = "SET_NOTE_SUCCESS";
